export const global = (theme) => ({
  html: {
    letterSpacing: theme.letterSpacing.negative,
  },

  // Prevent `100vw` causing issues in browsers (and OS) with scrollbars
  body: {
    overflowX: 'hidden',
  },

  //
  // Code blocks
  //
  pre: {
    maxHeight: 500,
    letterSpacing: 'normal',
    fontWeight: 400,
  },

  code: {
    letterSpacing: 'normal',
    fontWeight: 400,
  },

  //
  // Gatsby
  //

  // Gatsby-contained code block spacing
  '.gatsby-highlight': {
    '& + &': {
      marginTop: theme.space.base,
    },

    '* &': {
      marginTop: theme.space.base,
    },
  },

  // Figcaptions
  '.gatsby-resp-image-figcaption': {
    marginTop: theme.space.small,
    textAlign: 'center',
    fontSize: theme.fontSize.small,
  },

  // Images
  '.gatsby-resp-image-wrapper': {
    '* + &': {
      marginTop: theme.space.base,
    },
  },
})
